module.exports = __webpack_public_path__ + "Roboto-500.2a52a20f9a56010ec5d9.eot";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src634836211/src/src/assets/fonts/roboto/fonts/Roboto-500/Roboto-500.eot
// module id = ../../../../../src/assets/fonts/roboto/fonts/Roboto-500/Roboto-500.eot
// module chunks = main styles